import { BASE_HANDLER_URL } from ".";
import { DEFAULT_GRID_INFO_INBOX } from "../Components/Inbox/KendoInboxGrid";

export const loadInboxGridData = async (gridState) => {
  document.getElementById("loader").style.display = "block";
  const currentPage =
    gridState.pageNumber ?? DEFAULT_GRID_INFO_INBOX.currentPageNumber;
  const currentSize = gridState.pageSize ?? DEFAULT_GRID_INFO_INBOX.pageSize;
  const currentSortName =
    gridState.sort[0].field ?? DEFAULT_GRID_INFO_INBOX.sortName;
  const currentSortOrder =
    gridState.sort[0].dir ?? DEFAULT_GRID_INFO_INBOX.sortOrder;

  try {
    const formData = new FormData();
    formData.append("page", currentPage);
    formData.append("rp", currentSize);
    formData.append("sortname", currentSortName);
    formData.append("sortorder", currentSortOrder);
    formData.append("query", "");
    formData.append("qtype", "");

    const queryParams = new URLSearchParams({
      USERSEQNUM: sessionStorage.SEQ_NUM,
      APPUSER: sessionStorage.USER,
    }).toString();

    const url = `${BASE_HANDLER_URL}?class=${
      DEFAULT_GRID_INFO_INBOX.className
    }&action=${DEFAULT_GRID_INFO_INBOX.action}&${
      queryParams ? `${queryParams}` : ""
    }`;

    const result = await fetch(url, {
      method: "POST",
      body: formData,
    });

    const response = await result.json();
    if (response?.status === true) {
      document.getElementById("loader").style.display = "none";
      return response;
    } if (
      response?.status === false &&
      response?.Message ===
        "Collection was modified; enumeration operation may not execute."
    ) {
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
  document.getElementById("loader").style.display = "none";
};
